import { render } from "./IconMoving.vue?vue&type=template&id=32d90a28"
import script from "./IconMoving.vue?vue&type=script&lang=js"
export * from "./IconMoving.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__